

export const AdminUserListColumn = [
    {
        name: "Username",
        columnHeader:"admin.username",
        headerClassName: "ms-Grid-col ms-sm6 ms-lg3 ms-xl2",
        isDeactivateButton : false,
        isText: true,
        key: "username",
        sort: true,
        valueClassName: "ms-Grid-col ms-sm6 ms-lg3 ms-xl2 break-word"
    },
    {
        name: "FirstName",
        columnHeader: "admin.first-name",
        headerClassName: "ms-Grid-col ms-lg3 ms-xl2 ms-hiddenMdDown",
        isDeactivateButton : false,
        isText: true,
        key: "firstName",
        sort: true,
        valueClassName: "ms-Grid-col ms-lg3 ms-xl2 ms-hiddenMdDown break-word"
    },
    {
        name: "LastName",
        columnHeader: "admin.last-name",
        headerClassName: "ms-Grid-col ms-lg3 ms-xl2 ms-hiddenMdDown",
        isDeactivateButton : false,
        isText: true,
        key: "lastName",
        sort: true,
        valueClassName: "ms-Grid-col ms-lg3 ms-xl2 ms-hiddenMdDown break-word"
    },
    {
        name: "Email",
        columnHeader: "admin.email",
        headerClassName: "ms-Grid-col ms-xl2 ms-hiddenLgDown",
        isDeactivateButton : false,
        isText: true,
        key: "email",
        sort: true,
        valueClassName: "ms-Grid-col ms-xl2 ms-hiddenLgDown break-word"
    },
    {
        name: "Mobile",
        columnHeader: "admin.mobile",
        headerClassName: "ms-Grid-col ms-xl2 ms-hiddenLgDown",
        isDeactivateButton : false,
        isText: true,
        key: "mobile",
        sort: true,
        valueClassName: "ms-Grid-col ms-xl2 ms-hiddenLgDown break-word"
    },
    {
        name: "Status",
        columnHeader: "admin.status",
        headerClassName: "ms-Grid-col ms-sm6 ms-lg3 ms-xl2",
        isDeactivateButton : true,
        isText: false,
        button: {
            conditionVariable: "active",
            trueButtonValue: "button.deactivate",
            trueTextValue: "annotations.active",
            falseButtonValue: "button.activate",
            falseTextValue: "annotations.inactive"
        },
        sort: false,
        valueClassName: "ms-Grid-col ms-sm6 ms-lg3 ms-xl2 break-word"
    },
]